export const MENTOR_VISIBILITY_PUBLIC = 0
export const MENTOR_VISIBILITY_PRIVATE = 1
